<template>
  <a-layout class="hhxc-layout-wrap">
    <!-- <div
      v-if="device === 'mobile' && !collapse"
      class="hhxc-mask"
      @click="handleFoldSideBar"
    ></div> -->
    <a-layout-sider collapsible class="hhxc-sider" :width="150" :class="classObj" theme="dark" :hide-trigger="true">
      <!-- <hhxc-logo /> -->
      <a-menu
        class="hhxc-menu"
        theme="dark"
        mode="pop"
        v-model:selected-keys="selectedKeys"
        :default-selected-keys="selectedKeys"
        v-model:open-keys="openKeys"
        :auto-open-selected="true"
        :collapsed="collapse"
        showCollapseButton
        @collapse="toggleCollapse"
        style="width: 150px"
        :popup-max-height="1000"
      >
        <hhxc-menu v-for="route in routes" :key="route.path" :item="route" />
      </a-menu>
    </a-layout-sider>
    <a-layout class="hhxc-layout">
      <a-layout-header class="hhxc-header">
        <a-row justify="space-between" align="center">
          <a-col :span="20">
            <hhxc-tabs />
          </a-col>
          <a-col :span="4">
            <hhxc-avatar />
          </a-col>
        </a-row>
      </a-layout-header>
      <hhxc-content />
    </a-layout>
  </a-layout>
</template>
<script>
  import { computed, onBeforeMount, onBeforeUnmount, onMounted, reactive, toRefs, watch } from 'vue'
  import { useRoute } from 'vue-router'
  import { useStore } from 'vuex'
  import HhxcAvatar from './hhxc-avatar'
  import HhxcContent from './hhxc-content'
  import HhxcLogo from './hhxc-logo'
  import HhxcMenu from './hhxc-menu'
  import HhxcTabs from './hhxc-tabs'
  export default {
    components: {
      HhxcLogo,
      HhxcAvatar,
      HhxcMenu,
      HhxcTabs,
      HhxcContent,
    },
    setup() {
      const store = useStore()
      const route = useRoute()
      const myData = reactive({
        selectedKeys: [],
        openKeys: [],
      })
      myData.collapse = computed(() => {
        return store.getters['settings/collapse']
      })
      myData.routes = computed(() => {
        return store.getters['user/menuList']
      })
      myData.device = computed(() => {
        return store.getters['settings/device']
      })
      myData.classObj = computed(() => {
        return {
          // 'hhxc-mobile': myData.device === 'mobile',
          'hhxc-collapse': myData.collapse,
        }
      })
      let handleLayouts = () => {
        const width = document.body.getBoundingClientRect().width
        if (myData.width !== width) {
          const isMobile = width - 1 < 992
          store.dispatch('settings/toggleDevice', isMobile ? 'mobile' : 'desktop')
          myData.width = width
        }
      }
      myData.handleFoldSideBar = () => {
        return store.dispatch('settings/foldSideBar')
      }
      myData.toggleCollapse = () => {
        return store.dispatch('settings/toggleCollapse')
      }
      watch(
        route,
        ({ path, matched }) => {
          matched[0].children.length > 1 ? (myData.selectedKeys = [path]) : (myData.selectedKeys = [matched[0].path])
          myData.openKeys = [...new Set([...myData.openKeys, `/${matched[1]?.path?.split('/')[1]}`])]
        },
        { immediate: true }
      )

      onMounted(() => {
        handleLayouts()
      })
      onBeforeMount(() => {
        window.addEventListener('resize', myData.handleLayouts)
      })
      onBeforeUnmount(() => {
        window.removeEventListener('resize', myData.handleLayouts)
      })
      return {
        ...toRefs(myData),
      }
    },
  }
</script>
<style lang="less" scoped>
  /deep/.arco-menu-inner::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 4px;
  }
  /deep/.arco-menu-inner::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 5px;
    background: rgba(255, 253, 253, 0.205);
  }
  .hhxc-layout-wrap {
    .hhxc-sider {
      // position: fixed;
      left: 0;
      height: 100vh;
      overflow: auto;
      .hhxc-menu {
        height: 100vh;
      }
    }

    .hhxc-layout {
      height: 100vh;
      overflow: hidden;
      // padding-left: 150px;
      transition: all 0.2s;
      display: flex;
      flex: auto;
      flex-direction: column;
      background: #f2f2f2;
    }
    .hhxc-mobile-layout {
      padding-left: 0;
      transition: all 0.2s;
    }
    :deep(.hhxc-collapse) {
      width: 48px !important;
      .hhxc-logo .anticon + span {
        display: inline-block;
        max-width: 0;
        opacity: 0;
        transition: all 0.2s;
      }
      & + .hhxc-layout {
        // padding-left: 48px;
        transition: all 0.2s;
        .hhxc-header {
          // width: calc(100% - 48px);
        }
      }
    }
    .hhxc-mask {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 998;
      width: 100%;
      height: 100vh;
      overflow: hidden;
      background: #000;
      opacity: 0.5;
    }
    .hhxc-mobile {
      position: fixed !important;
      z-index: 999;
      &.hhxc-collapse {
        width: 0 !important;
        min-width: 0 !important;
        max-width: 0 !important;
        * {
          display: none !important;
          width: 0 !important;
          min-width: 0 !important;
          max-width: 0 !important;
        }
        .ant-menu-item,
        .ant-menu-submenu {
          display: none !important;
          width: 0 !important;
          min-width: 0 !important;
          max-width: 0 !important;
        }
        & + .hhxc-layout {
          padding-left: 0px !important;
          transition: all 0.2s;
        }
      }
    }
    .hhxc-header {
      padding: 0;
      height: @hhxc-header-height;
      backdrop-filter: blur(8px);
      box-shadow: inset 0 -1px 1px #e5eaf2;
      background-color: rgba(255, 255, 255, 0.8);
      // box-shadow: 0 1px 4px rgb(0 21 41 / 8%);
      // position: fixed;
      // width: calc(100% - 150px);
      // border-bottom: 1px solid var(--color-neutral-3);
      width: 100%;
      z-index: 19;
      right: 0px;
      top: 0px;
      // background: #fff;
      .ant-col + .ant-col {
        display: flex;
        justify-content: flex-end;
        padding: 0 @hhxc-padding;
      }
      .trigger {
        height: @hhxc-header-height;
        padding: 0 @hhxc-padding;
        font-size: 18px;
        line-height: @hhxc-header-height;
        cursor: pointer;
        transition: color 0.3s;
        &:hover {
          color: #1890ff !important;
        }
      }
    }
  }
</style>
